gsap.registerPlugin(ScrollTrigger);
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- loading screen: campaign photo -> swipe reveal ---------- */
const loaderEl = document.getElementById('loader');
const swipeEl = document.getElementById('loaderSwipe');
gsap.set(swipeEl,{xPercent:-101});

const loaderTl = gsap.timeline();
loaderTl
  .to('.loader-photo img',{scale:1,duration:2.6,ease:'power1.out'},0)
  .to('#loaderMark',{opacity:1,duration:.6,ease:'power2.out'},.5)
  .to(swipeEl,{xPercent:0,duration:.6,ease:'power3.inOut'},1.9)
  .set(loaderEl,{display:'none'})
  .to(swipeEl,{xPercent:101,duration:.8,ease:'power3.inOut'},'>')
  .call(()=>{ introTl.play(); },[],'<')
  .set(swipeEl,{display:'none'},'>');

/* ---------- hero intro ---------- */
const introTl = gsap.timeline({paused:true});
gsap.set('.hero-cta-row,.hero-tags',{opacity:0,y:14});
gsap.set('.collage-card',{opacity:0,y:40,scale:.92});
introTl
  .to('#heroLogo',{y:'0%',duration:1.3,ease:'power2.out'})
  .to('.hero-title .row span',{y:'0%',duration:1.1,stagger:.15,ease:'power2.out'},'-=.8')
  .to('.hero-sub span',{y:'0%',duration:.8,ease:'power3.out'},'-=.5')
  .to('.hero-tags',{opacity:1,y:0,duration:.6},'-=.4')
  .to('.hero-cta-row',{opacity:1,y:0,duration:.6},'-=.4')
  .to('.collage-3',{opacity:1,y:0,scale:1,duration:.9,ease:'power3.out'},'-=.9')
  .to('.collage-2',{opacity:1,y:0,scale:1,duration:.9,ease:'power3.out'},'-=.75')
  .to('.collage-1',{opacity:1,y:0,scale:1,duration:.9,ease:'power3.out'},'-=.6');

/* ---------- nav shrink on scroll ---------- */
const header = document.getElementById('siteHeader');
ScrollTrigger.create({start:60,end:99999,onUpdate:(self)=>{header.classList.toggle('scrolled', self.scroll()>60);}});

/* ---------- hero collage parallax + idle float ---------- */
if(!reduceMotion){
  document.querySelectorAll('.collage-card').forEach((card,i)=>{
    gsap.to(card,{y:'+=9',duration:4+i*.5,repeat:-1,yoyo:true,ease:'sine.inOut',delay:i*.3});
  });
  const heroEl = document.querySelector('.hero');
  if(heroEl && window.innerWidth>900){
    heroEl.addEventListener('mousemove',(e)=>{
      const x = (e.clientX/window.innerWidth - .5);
      const y = (e.clientY/window.innerHeight - .5);
      gsap.to('.collage-1',{x:x*10,y:y*8,duration:1.1,ease:'power2.out'});
      gsap.to('.collage-2',{x:x*15,y:y*11,duration:1.1,ease:'power2.out'});
      gsap.to('.collage-3',{x:x*19,y:y*14,duration:1.1,ease:'power2.out'});
    });
  }
}

/* ---------- scroll reveals ---------- */
gsap.utils.toArray('.reveal').forEach((el,i)=>{
  gsap.to(el,{opacity:1,y:0,duration:1.2,ease:'power2.out',
    scrollTrigger:{trigger:el,start:'top 88%'}});
});

/* ---------- collection cards stagger + image parallax ---------- */
gsap.utils.toArray('.coll-card').forEach((card)=>{
  gsap.to(card.querySelector('.ph'),{
    yPercent:-8,ease:'none',
    scrollTrigger:{trigger:card,start:'top bottom',end:'bottom top',scrub:true}
  });
});

/* ---------- craft section: annotated photo reveal ---------- */
const craftTl = gsap.timeline({
  scrollTrigger:{trigger:'#craft',start:'top 72%'}
});
craftTl
  .to('.craft-photo-card',{opacity:1,scale:1,rotate:-3,duration:.9,ease:'back.out(1.4)'})
  .to('.craft-headline .row span',{y:'0%',duration:.9,stagger:.12,ease:'power2.out'},'-=.6')
  .to('#craftP',{opacity:.8,y:0,duration:.7,ease:'power2.out'},'-=.5')
  .to('#craftCta',{opacity:1,y:0,duration:.6,ease:'power2.out'},'-=.4')
  .to('.callout-colors',{opacity:1,duration:.5},'-=.9')
  .to('.callout-colors .swatches i',{scale:1,duration:.5,stagger:.08,ease:'back.out(2)'},'-=.4')
  .to('.callout-colors .arrow-icon',{opacity:1,duration:.5},'-=.3')
  .to('.callout-fabric',{opacity:1,duration:.5},'-=.5')
  .to('.callout-fabric .arrow-icon',{opacity:1,duration:.5},'-=.3')
  .to('.callout-gsm',{opacity:1,duration:.5},'-=.4')
  .to('.callout-gsm .arrow-icon',{opacity:1,duration:.5},'-=.3');

if(!reduceMotion){
  gsap.to('.craft-photo-card',{y:'+=10',duration:3.6,repeat:-1,yoyo:true,ease:'sine.inOut',delay:1.5});
}

/* ---------- brand story word reveal ---------- */
gsap.utils.toArray('#storyTitle .word').forEach((w)=>{
  gsap.to(w,{opacity:1,duration:.4,ease:'none',
    scrollTrigger:{trigger:w,start:'top 78%',end:'top 55%',scrub:true}});
});

/* ---------- custom cursor ---------- */
const cursor = document.getElementById('cursor');
const cursorLabel = document.getElementById('cursorLabel');
if(!reduceMotion && window.innerWidth>900){
  window.addEventListener('mousemove',(e)=>{
    gsap.to(cursor,{x:e.clientX,y:e.clientY,duration:.15,ease:'power2.out'});
    gsap.to(cursorLabel,{x:e.clientX,y:e.clientY,duration:.15,ease:'power2.out'});
  });
  document.querySelectorAll('a,button,.product,.coll-card,.slide').forEach((el)=>{
    el.addEventListener('mouseenter',()=>{
      if(el.classList.contains('product')||el.classList.contains('coll-card')||el.classList.contains('slide')){
        cursor.classList.add('tag'); cursorLabel.textContent='View'; cursorLabel.classList.add('show');
      } else { cursor.classList.add('ring'); }
    });
    el.addEventListener('mouseleave',()=>{ cursor.classList.remove('tag','ring'); cursorLabel.classList.remove('show'); });
  });
}

/* ---------- magnetic buttons ---------- */
document.querySelectorAll('.hero-cta, .nl-form button, .slide-arrow, .craft-cta').forEach((btn)=>{
  btn.addEventListener('mousemove',(e)=>{
    const r = btn.getBoundingClientRect();
    const x = e.clientX - r.left - r.width/2, y = e.clientY - r.top - r.height/2;
    gsap.to(btn,{x:x*.15,y:y*.2,duration:.5,ease:'power2.out'});
  });
  btn.addEventListener('mouseleave',()=>{ gsap.to(btn,{x:0,y:0,duration:.5,ease:'elastic.out(1,0.4)'}); });
});

/* ---------- spotlight slider ---------- */
const slides = Array.from(document.querySelectorAll('.slide'));
const caption = document.getElementById('slideCaption');
let active = 2;
function renderSlides(){
  const n = slides.length;
  slides.forEach((s,i)=>{
    const diff = (i - active + n) % n;
    if(diff===0) s.dataset.pos='center';
    else if(diff===1) s.dataset.pos='right';
    else if(diff===n-1) s.dataset.pos='left';
    else if(diff===2) s.dataset.pos='hide-right';
    else s.dataset.pos='hide-left';
  });
  gsap.fromTo(caption,{opacity:0,y:6},{opacity:1,y:0,duration:.4,ease:'power2.out'});
  caption.textContent = slides[active].dataset.tag;
}
document.getElementById('nextBtn').addEventListener('click',()=>{active=(active+1)%slides.length;renderSlides();});
document.getElementById('prevBtn').addEventListener('click',()=>{active=(active-1+slides.length)%slides.length;renderSlides();});
slides.forEach((s,i)=>{
  s.addEventListener('click',(e)=>{
    // first click centres the slide; a second click on the active slide follows the link
    if(i !== active){ e.preventDefault(); active=i; renderSlides(); }
  });
});
renderSlides();

/* touch swipe */
let touchX=null;
const track = document.getElementById('slideTrack');
track.addEventListener('touchstart',(e)=>{touchX=e.touches[0].clientX;});
track.addEventListener('touchend',(e)=>{
  if(touchX===null) return;
  const dx = e.changedTouches[0].clientX - touchX;
  if(dx<-40){active=(active+1)%slides.length;renderSlides();}
  else if(dx>40){active=(active-1+slides.length)%slides.length;renderSlides();}
  touchX=null;
});
